import { BackOfficePrivilegeName } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { extractGraphqlError } from '@new/domains/finance/screens/RevenueAgents/utils/graphqlError'

// Switch to BackOfficePrivilegeName.legalDocumentsRead once the generated client has it.
export const LEGAL_DOCUMENTS_READ = 'LEGAL_DOCUMENTS_READ' as BackOfficePrivilegeName

export const isForbiddenError = (error: unknown) => extractGraphqlError(error).code === 'FORBIDDEN'
